<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: "App"
};
</script>
<style lang="less">
.el-header {
  padding: 0;
  height: auto !important;
  z-index: 100;
}
</style>



// WEBPACK FOOTER //
// src/App.vue